import { getUrlParams, getUrlWithParams } from 'core-components/helpers/url'
import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'

export const getRedirectUrl = (url: string, sitePage: ISitePage) => {
  if (sitePage.redirectWithParams) {
    const urlParams = getUrlParams()
    if ('page' in urlParams) {
      delete urlParams.page
    }
    return getUrlWithParams(urlParams, url)
  }
  return url
}
